<template>
  <div class="animated fadeIn">
    <b-card size="sm">
      <div slot="header">
        <i class="icon-note"></i> Pointing Toko dengan DC
      </div>

      <b-card-body>
        <b-row>
          <b-col sm="12" lg="12">
            <google-map
              :data-dc="dc"
              :data-store="stores"
              :label-button="'Simpan'"
              @submitButton="submitButton"
            ></google-map>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="12" lg="12">&nbsp;</b-col>
        </b-row>
        <b-row>
          <b-col sm="12" lg="12">
            <global-table
              :table-data="unlisted"
              :loading="loading"
              :per-page="10"
              :bordered="true"
              :table-detail="tableDetail"
              :hover="true"
              :striped="false"
              :fields="fields"
              :edit-row="addForm"
              :redirect-detail="false"
              :show-add-button="false"
              caption="<i class='fa fa-align-justify'></i> Daftar yang belum ada koordinat"
              addButton="Permission Leave"
              @editForm="editForm"
              @isEdit="isEdit"
              @resetForm="resetForm"
            ></global-table>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <b-modal
              ref="myModalRef"
              id="addModals"
              header-border-variant="no-border text-center"
              footer-border-variant="no-border"
              footer-bg-variant="light"
              :no-close-on-backdrop="true"
              :no-close-on-esc="true"
              size="lg"
            >
              <div slot="modal-header" class="text-center">
                <h3 class="text-center">Masukkan koordinat</h3>
              </div>

              <b-form id="coordinatForm" validated novalidate>
                <b-row>
                  <b-col sm="4">
                    <b-col sm="12">
                      <b-form-group label-for="lat" label="Latitude">
                        <b-form-input
                          id="lat"
                          type="text"
                          v-model="$v.addForm.lat.$model"
                          :state="!$v.addForm.lat.$invalid"
                          required
                        ></b-form-input>
                        <b-form-invalid-feedback>Latitude harus di isi.</b-form-invalid-feedback>
                      </b-form-group>

                      <b-form-group label-for="long" label="Longitude">
                        <b-form-input
                          id="long"
                          type="text"
                          v-model="$v.addForm.long.$model"
                          :state="!$v.addForm.long.$invalid"
                          required
                        ></b-form-input>
                        <b-form-invalid-feedback>Longitude harus di isi.</b-form-invalid-feedback>
                      </b-form-group>
                    </b-col>
                  </b-col>
                </b-row>
              </b-form>

              <div slot="modal-footer" class="float-right">
                <b-button type="button" size="sm" variant="danger" @click="cancelAdd">
                  <i class="fa fa-undo"></i> Back
                </b-button>&nbsp;
                <b-button
                  type="button"
                  size="sm"
                  variant="primary"
                  @click="submitAdd"
                  :disabled="$v.addForm.$invalid"
                >
                  <i class="fa fa-save"></i> Save
                </b-button>
              </div>
            </b-modal>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>


<script>
import globalTable from "../../templates/Table.vue";
import { Callout } from "@coreui/vue";
import GoogleMap from "../../components/GoogleMap";
import axios from "axios";
import interfaces from "@/templates/_interfaces.js";
import { required } from "vuelidate/lib/validators";

export default {
  name: "mitra",
  components: {
    Callout,
    GoogleMap,
    globalTable
  },
  props: {
    flag: {
      type: Boolean,
      default: false
    },
    tableDetail: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dc: [],
      stores: [],
      unlisted: [],
      listMitra: [],
      loading: false,
      id: null,
      addForm: interfaces.indomaret,
      fields: [
        { key: "store_code", sortable: true },
        { key: "title", label: "Name", sortable: true },
        { key: "address", label: "Alamat" },
        { key: "action", class: "text-center" }
      ]
    };
  },
  validations: {
    addForm: {
      dc_code: {},
      name: {},
      store_code: {},
      address: {},
      lat: { required },
      long: { required }
    }
  },
  notifications: {
    showErrorNotification: {
      title: "Error Title",
      message: "Messages",
      type: "error"
    },
    showInfoNotification: {
      title: "Info Title",
      message: "Messages",
      type: "info"
    }
  },
  methods: {
    init: function() {
      this.loading = true;
      this.axios
        .get("md/mitra/")
        .then(response => {
          this.dc = response.data.data;
          this.stores = response.data.data2;
          this.unlisted = response.data.data3;
        })
        .catch(error => {})
        .finally(() => {
          this.loading = false;
        });
    },
    submitButton: function(dc_code, id) {
      if (confirm("Apakah anda toko ini ingin di pointing ke DC ?")) {
        let dc = {}
        dc.dc_code = dc_code
        dc.id = id
        this.axios
          .put("md/update_dc_code/", dc)
          .then(response => {
            //this.listMitra = response.data.data;
            this.handleSubmit()
            this.showInfoNotification({
              title: "Pointing DC",
              message: response.data.message
            });
            this.$router.push({ path: "/mitra/dc" });
          })
          .catch(error => {})
          .finally(() => {
            //this.loading = false;
          });
      }
    },
    submitAdd: function(evt) {
      evt.preventDefault();
      if (confirm("Apakah anda ingin menambahkan koordinat ?")) {
        this.addForm.id = this.id
        this.axios
          .put("md/update_coordinat/", this.addForm)
          .then(response => {
            //this.listMitra = response.data.data;
            this.showInfoNotification({
              title: "Pointing Koordinat",
              message: response.data.message
            });
            this.handleSubmit()
            this.$router.push({ path: "/mitra/dc" });
          })
          .catch(error => {})
          .finally(() => {
            //this.loading = false;
          });
        //console.log(this.addForm);
      }
    },
    handleSubmit: function() {
      this.resetForm();
      this.$refs.myModalRef.hide();
      this.init();
    },
    editForm: function(a) {
      this.resetForm();
      this.id = null
      this.id = a.id
    },
    cancelAdd: function() {
      this.$refs.myModalRef.hide();
    },
    resetForm: function() {
      for (var a in interfaces.indomaret) {
        interfaces.indomaret[a] = null
      }
      this.addForm = interfaces.indomaret
    },
    isEdit: function(flag) {
      this.editFlag = flag;
    }
  },
  mounted() {
    this.init();
  }
};
</script>